// Simples Nacional em 2027 (NT 2026.005 v1.00). Textos EXATOS da NT, p. 8 (C21a e I17d).
// O cadastro é do escritório; o XML com esses campos só sai quando o schema oficial for
// publicado (chave desligada no servidor). Nenhuma regra fiscal mora aqui: só os rótulos.

// I17d — cAtivSN (p. 8)
export const CATIVSN = [
  { valor: '01', rotulo: '01 = Revenda de mercadorias, venda de mercadorias industrializadas pelo contribuinte - Anexo I.' },
  { valor: '02', rotulo: '02 = Operações com os demais bens materiais, sem incidência de ICMS – Anexo I.' },
  { valor: '03', rotulo: '03 = Venda de mercadorias industrializadas pelo contribuinte, com industrialização incentivada na Zona Franca de Manaus - Anexo II.' },
  { valor: '04', rotulo: '04 = Operações com os demais bens materiais, com industrialização incentivada na Zona Franca de Manaus, sem incidência de ICMS - Anexo II.' },
  { valor: '90', rotulo: '90 = Operações não Tributáveis.' },
];

// C21a — tpRegimeIBSCBS (p. 8). Só 2, 3 e 4 ficam no cadastro da empresa do Regime Normal;
// o "1" (Simples com opção pelo regime regular) vem do regime de apuração do IBS/CBS.
export const TP_REGIME_CRT3 = [
  { valor: 2, rotulo: '2 = Contribuinte do Regime Normal (CRT=3) com opção pendente pelo CRT="1-Simples Nacional" sem regime regular do IBS e da CBS' },
  { valor: 3, rotulo: '3 = Contribuinte do Regime Normal (CRT=3) com opção pendente pelo CRT="2-Simples Nacional, excesso sublimite de receita bruta" sem regime regular do IBS e da CBS' },
  { valor: 4, rotulo: '4 = Contribuinte do Regime Normal (CRT=3) com opção pendente pelo Simples Nacional (CRT=1 ou 2), com regime regular do IBS e da CBS' },
];

// Empresa que informa o cAtivSN nos itens (NT p. 5, 2.2): CRT 1 ou 2, ou CRT 3 com tp 2, 3 ou 4.
// MEI (CRT 4) nunca (p. 7).
export function usaCativsn(empresa) {
  if (!empresa) return false;
  const crt = Number(empresa.regime_tributario);
  return crt === 1 || crt === 2 || (crt === 3 && [2, 3, 4].includes(Number(empresa.tp_regime_ibscbs)));
}

export function rotuloCativsn(valor) {
  const o = CATIVSN.find(c => c.valor === valor);
  return o ? o.rotulo : 'Não informado';
}

// Quadro "Pendências por empresa" (escritório): avisos do Simples 2027 (não bloqueiam).
// Campos do servidor: simples_2027_sem_grupo, simples_2027_sem_cativsn, simples_2027_aliquota_mes.
export function avisoSimples2027(p) {
  if (!p) return null;
  const partes = [];
  if (p.simples_2027_sem_cativsn) partes.push(`${p.simples_2027_sem_cativsn} produto(s) sem atividade do Simples (cAtivSN)`);
  if (p.simples_2027_aliquota_mes) partes.push(`alíquota efetiva de ${p.simples_2027_aliquota_mes} não cadastrada`);
  if (p.simples_2027_sem_grupo) partes.push('notas de 2027 saindo sem o grupo IBS/CBS (aguarda o schema oficial)');
  if (p.simples_regime_regular) partes.push(`opção pelo regime regular do IBS/CBS desde ${p.simples_regime_regular}: as notas saem sem o grupo IBS/CBS até o schema oficial`);
  return partes.length ? partes.join('; ') : null;
}
